module.exports = __webpack_public_path__ + "img/cyprus.ea0561b6.svg";